import AppProvider from 'components/provider'
import { BrowserRouter } from 'react-router-dom'
import { ErrorBoundary } from 'components/error-boundary'

import Routes from 'routes'

const App = () => (
  <ErrorBoundary>
    <BrowserRouter>
      <AppProvider>
          <Routes />
      </AppProvider>
    </BrowserRouter>
  </ErrorBoundary>
)

export default App
